import React, { useState, forwardRef, useEffect, useMemo, useRef } from "react";
import { useHistory, Link, useLocation } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { get } from "lodash";
import Model from "../shared/model";
import moment from "moment";
import Card from "@mui/material/Card";
import ReactTooltip from "react-tooltip";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Divider from "@mui/material/Divider";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import MaterialTable from "@material-table/core";
import editIcon from "../../assests/images/editIcon.svg";
import viewIcon from "../../assests/images/infoReq.svg";
import { useTranslation } from "react-i18next";
import { addressSearchStyles } from "./addressStyles";
import { utils, writeFile } from "xlsx";
import _ from "lodash";
import * as config from "../../config";
import { DateFormat,DateWithDefaultTime,DateWithEndTime,DateFormatWithoutLocal } from "../common/utils/DateUtil";
import { STATUS, USERROLES, PROCESS_MANAGER, INSPECT } from "../../constants";
import StatusFlow from "../shippingRequest/statusFlow";
import { shippingRequestEdit } from "../shippingRequest/shippingRequest";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import {
  AddBox,
  ArrowDownward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FilterList,
  FirstPage,
  LastPage,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
} from "@material-ui/icons";
import {
  dateSortFunction,
  ifRequestCompletedApprovals,
  sortFunction,
  SortFunctionNew,
} from "../../Services/util";
import { TYPE_OF_SHIPMENT ,months} from "../../constants";
import {
  tableRowFormatter,
  tableRowOrderManager,
} from "../common/utils/TableUtil";
import trans from "../../Translations/english.json";
const status=trans.status;

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const ProcessShippingRequestListingComponent = (props) => {
  const [selected, setSelected] = useState("");
  const { instance } = useMsal();
  const userId = instance.getActiveAccount().username;
  // const [disableOrderPickup, setDisableOrderPickup] = useState(true);
  const [isExportModalVisible, setIsExportModalVisible] = useState(false);
  const [requiredFileName, setrequiredFileName] = useState("");
  const [isExportModalVisibleSingle, setIsExportModalVisibleSingle] =
    useState(false);
  var userType = JSON.parse(localStorage.getItem("userType"));
  const {
    processShippmentList,
    actions,
    searchFilter,
    setIsLoading,
    allMaterials,
    handleHandBack,
    handleCancelRequest,
    handleCloseRequest,
    shippingSearchAutocompleteData,
    handlerShippingInspect,
    shippingType,
    tableProcessShippingOptions
  } = props;

  const [filteredData, setfilteredData] = useState([]);
  const [columnsResetKey, setColumnsResetKey] = useState(0);
  const [columnsPopupOpen, setColumnsPopupOpen] = useState(false);
  const { t, i18n } = useTranslation();
  const defaultColumnVisibility = {
    internal_distribution_number: true,
    create_date: true,
    created_by: true,
    final_recipient: true,
    name_english: true,
    country_of_shipper: true,
    type_of_shipment: true,
    shipment_date_mon: true,
    shipment_date_lev: true,
    tracking_number: true,
    status: true,
    review_by_shipping: true,
    stat_materials: false,
    logistics_partner:false
  };
  const [columnVisibility, setColumnVisibility] = useState({
    ...defaultColumnVisibility,
    ...(tableProcessShippingOptions?.columnVisibility || {}),
  });
  const classes = addressSearchStyles();
  const history = useHistory();

  const columnToggleList = [
    { key: "internal_distribution_number", label: t("shippingrequest.internalorderid") },
    { key: "create_date", label: t("materials.create_date") },
    { key: "created_by", label: t("materials.create_user") },
    { key: "final_recipient", label: t("shippingrequest.finalrecipient") },
    { key: "name_english", label: t("shippingrequest.addreesedcountry") },
    { key: "country_of_shipper", label: t("shippingrequest.country_of_shipper") },
    { key: "type_of_shipment", label: t("title.ShipmentType") },
    { key: "shipment_date_mon", label: t("shippingrequest.dispatchdate(mon)") },
    { key: "shipment_date_lev", label: t("shippingrequest.dispatchdate(lev)") },
    { key: "tracking_number", label: t("shippingrequest.trackingnumber") },
    { key: "status", label: t("shippingrequest.status") },
    { key: "review_by_shipping", label: t("shipping_request.assigned_shipping_review") },
    { key: "stat_materials", label: t("materials.materials") },
    {key:  "logistics_partner", label: t("shippingrequest.logistics_partner")}
  ];

  // Refs so ColumnsToolbar (memoised with []) can call latest handlers without re-creating
  const openPopupRef = useRef(() => {});
  openPopupRef.current = () => setColumnsPopupOpen(true);
  const resetColumnsRef = useRef(() => {});
  resetColumnsRef.current = () => { setColumnsResetKey((k) => k + 1); setColumnVisibility(defaultColumnVisibility); };
  const tRef = useRef(t);
  tRef.current = t;

  // Stable toolbar — empty deps means MaterialTable never sees a new component type → no flicker
  const ColumnsToolbar = useMemo(() => {
    return function ColumnsToolbarInner() {
      return (
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "flex-start",
          gap: "12px", backgroundColor: "#f0f0f0", height: "35px",
          padding: "0 8px", boxSizing: "border-box",
          color: "#414141", fontSize: "15px", fontWeight: "bold",
        }}>
          <span>{tRef.current?.("approve_recipient.search_text")}</span>
          <>
            <button
              className="btn btn-sm btn-outline-secondary"
              style={{ color: "#1a86ce", fontSize: "12px", fontWeight: "bold" }}
              onClick={() => resetColumnsRef.current()}
              data-tip="Reset to show all columns"
              data-for="reset-columns-tip"
            >
              {t("commonlabels.resetColumns")}
            </button>
            <ReactTooltip id="reset-columns-tip" place="bottom" effect="solid" />
          </>
          <button
            className="btn btn-sm btn-outline-secondary"
            style={{ color: "#1a86ce", fontSize: "12px", fontWeight: "bold" }}
            onClick={() => openPopupRef.current()}
          >
            {t("commonlabels.showHideColumns")}
          </button>
        </div>
      );
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [shippingDetail, setShippingDetail] = useState({});
  const [actionName, setActionName] = useState("");

  const cardTheme = {
    cardHeaderStylePref: {
      background: "linear-gradient(to right bottom, #D8D8D8, #E0E0E0)",
      color: "#000000",
      height: 30,
      padding: 0,
    },
  };

  useEffect(() => {
    let validSearchKeys = Object.keys(searchFilter).filter(
      (key) => !!searchFilter[key] && key !== "searchKey"
    );

    const normalizeSearchValues = (value) => {
      if (!value) {
        return [];
      }

      if (Array.isArray(value)) {
        return value
          .map((item) => {
            if (typeof item === "string") {
              return item;
            }
            return item?.label || item?.value || "";
          })
          .map((item) => item.toString().trim())
          .filter(Boolean);
      }

      if (typeof value === "string") {
        const normalizedValue = value.trim();
        return normalizedValue ? [normalizedValue] : [];
      }

      const optionValue = value?.label || value?.value || "";
      const normalizedOptionValue = optionValue.toString().trim();
      return normalizedOptionValue ? [normalizedOptionValue] : [];
    };

    let matchedShippmentIds = false;
    let matchedShippmentIdsByMaterial = [];
    let matchedShippmentIdsByHtsChina = [];
    let matchedShippmentIdsByHtsGermany = [];
    let matchedShippmentIdsByHtsUsa = [];

    const materialSearchValues = normalizeSearchValues(searchFilter.material);
    const hasMaterialSearch = materialSearchValues.length > 0;
    const htsChinaSearchValues = normalizeSearchValues(searchFilter.statistical_material_number_china);
    const htsGermanySearchValues = normalizeSearchValues(searchFilter.statistical_material_number_grmny);
    const htsUsaSearchValues = normalizeSearchValues(searchFilter.statistical_material_number_usa);
    const hasHtsChinaSearch = htsChinaSearchValues.length > 0;
    const hasHtsGermanySearch = htsGermanySearchValues.length > 0;
    const hasHtsUsaSearch = htsUsaSearchValues.length > 0;

    if (validSearchKeys.includes("description")) {
      matchedShippmentIds = shippingSearchAutocompleteData?.materialData
        ?.filter((item) =>
          item.description
            .toLowerCase()
            .includes(searchFilter.description.trim().toLowerCase())
        )
        .map((item) => item.shipping_request_id);
    }

    if (validSearchKeys.includes("material") && hasMaterialSearch) {
      matchedShippmentIdsByMaterial = shippingSearchAutocompleteData?.materialData
        ?.filter((item) => {
          if (Array.isArray(searchFilter.material)) {
            return materialSearchValues.includes(item.description);
          }
          return item.description
            ?.toLowerCase()
            .includes((materialSearchValues[0] || "").trim().toLowerCase());
        })
        .map((item) => item.shipping_request_id) || [];
    }

    if (hasHtsChinaSearch) {
      matchedShippmentIdsByHtsChina = shippingSearchAutocompleteData?.materialData
        ?.filter((item) => {
          const value = (item.statistical_material_number_china || "").toLowerCase();
          return htsChinaSearchValues.some((searchValue) =>
            value === searchValue.toLowerCase()
          );
        })
        .map((item) => item.shipping_request_id) || [];
    }

    if (hasHtsGermanySearch) {
      matchedShippmentIdsByHtsGermany = shippingSearchAutocompleteData?.materialData
        ?.filter((item) => {
          const value = (item.statistical_material_number_grmny || "").toLowerCase();
          return htsGermanySearchValues.some((searchValue) =>
            value === searchValue.toLowerCase()
          );
        })
        .map((item) => item.shipping_request_id) || [];
    }

    if (hasHtsUsaSearch) {
      matchedShippmentIdsByHtsUsa = shippingSearchAutocompleteData?.materialData
        ?.filter((item) => {
          const value = (item.statistical_material_number_usa || "").toLowerCase();
          return htsUsaSearchValues.some((searchValue) =>
            value === searchValue.toLowerCase()
          );
        })
        .map((item) => item.shipping_request_id) || [];
    }

    const hasGroupOrFilters =
      hasMaterialSearch || hasHtsChinaSearch || hasHtsGermanySearch || hasHtsUsaSearch;

    const groupedMaterialAndHtsMatches = [];
    if (hasMaterialSearch) {
      groupedMaterialAndHtsMatches.push(new Set(matchedShippmentIdsByMaterial));
    }
    if (hasHtsChinaSearch) {
      groupedMaterialAndHtsMatches.push(new Set(matchedShippmentIdsByHtsChina));
    }
    if (hasHtsGermanySearch) {
      groupedMaterialAndHtsMatches.push(new Set(matchedShippmentIdsByHtsGermany));
    }
    if (hasHtsUsaSearch) {
      groupedMaterialAndHtsMatches.push(new Set(matchedShippmentIdsByHtsUsa));
    }
  
    const filteredData = processShippmentList.filter((item) => {

      if((item.status===STATUS.CANCELLED)||(item.status===STATUS.IN_DELIVERY)){
        return false;
      }
      if (matchedShippmentIds && !matchedShippmentIds.includes(item.id) ) {
        return false;
      }

      if (
        hasGroupOrFilters &&
        !groupedMaterialAndHtsMatches.every((matchedIdsSet) => matchedIdsSet.has(item.id))
      ) {
        return false;
      }

      for (let searchParam of validSearchKeys) {

        if (
          [
            "description",
            "material",
            "statistical_material_number_china",
            "statistical_material_number_grmny",
            "statistical_material_number_usa",
          ].includes(searchParam)
        ) {
          continue;
        }
        if (["submitted", "approved", "valid","review_by_shipping"].includes(searchParam)) {
          if (searchParam === "review_by_shipping" && item[searchParam] !== null) {
            continue;
          }
          if (item[searchParam] !== 1) {
            return false;
          } else {
            continue;
          }
        }

        if (["startDate", "endDate"].includes(searchParam)) {
          if (!item.created_on) {
            return false;
          }
          const createDate = moment(item.created_on).startOf(
            "day"
          );
          const date = moment(searchFilter[searchParam]).startOf("day");
          if (searchParam === "startDate") {
            if (createDate.isBefore(DateWithDefaultTime(date))) {
              return false;
            }
            continue;
          } else {
            if (createDate.isAfter(DateWithEndTime(date))) {
              return false;
            }
            continue;
          }
        }

        if (
          ["shipmentDateLevStart", "shipmentDateLevEnd"].includes(searchParam)
        ) {
          if (!item.shipment_date_lev) {
            return false;
          }
          const createDate = moment(item.shipment_date_lev).startOf("day");
          const date = moment(searchFilter[searchParam]).startOf("day");
          if (searchParam === "shipmentDateLevStart") {
            if (createDate.isBefore(DateWithDefaultTime(date))) {
              return false;
            }
            continue;
          } else {
            if (createDate.isAfter(DateWithEndTime(date))) {
              return false;
            }
            continue;
          }
        }

        if (
          ["shipmentDateMomStart", "shipmentDateMomEnd"].includes(searchParam)
        ) {
          if (!item.shipment_date_mon) {
            return false;
          }
          const createDate = moment(item.shipment_date_mon).startOf("day");
          const date = moment(searchFilter[searchParam]).startOf("day");
          if (searchParam === "shipmentDateMomStart") {
            if (createDate.isBefore(DateWithDefaultTime(date))) {
              return false;
            }
            continue;
          } else {
            if (createDate.isAfter(DateWithEndTime(date))) {
              return false;
            }
            continue;
          }
        }

        if (
          ["dateOfRecipientStart", "dateOfRecipientEnd"].includes(searchParam)
        ) {
          if (!item.close_date) {
            return false;
          }
          const createDate = moment(item.close_date).startOf("day");
          const date = moment(searchFilter[searchParam]).startOf("day");
          if (searchParam === "dateOfRecipientStart") {
            if (createDate.isBefore(DateWithDefaultTime(date))) {
              return false;
            }
            continue;
          } else {
            if (createDate.isAfter(DateWithEndTime(date))) {
              return false;
            }
            continue;
          }
        }

    if (["final_receipt"].includes(searchParam) && searchFilter[searchParam].length>0) {
          if (
             !searchFilter[searchParam].includes(item["firstname"] + " " + item["lastname"])
          ) {
            return false;
          }
          continue;
        }

      //   if(  searchParam=" internal_distribution_number " &&
      //   !(
      //     item[searchParam] &&
      //     item[searchParam]
      //       .toLowerCase()
      //       .includes(searchFilter[searchParam].trim().toLowerCase())
      //   )
      // ){
      //   return false
      // }
 if (
      searchParam == "created_by" && searchFilter[searchParam].length > 0 && (
    !item[searchParam] ||
    !(item[searchParam] + "")
      .toLowerCase()
      .includes(searchFilter[searchParam].trim().toLowerCase())
        
      )
    ) {
      return false;
    }
    if (
      searchParam == "internal_distribution_number" && searchFilter[searchParam].length > 0 && (
    !item[searchParam] ||
    !(item[searchParam] + "")
      .toLowerCase()
      .includes(searchFilter[searchParam].trim().toLowerCase())
        
      )
    ) {
      return false;
    }
     if (
      searchParam=="city" && !(
       (item[searchParam] || "").toLowerCase().includes((searchFilter[searchParam] || "").trim().toLowerCase())
     )
   ) {
     return false;
   }
   if (
    searchParam=="tracking_number" && !(
     (item[searchParam]?.replace(/\s+/g,'') || "").toLowerCase().includes((searchFilter[searchParam]?.replace(/\s+/g,'') || "").toLowerCase())
   )
 ) {
   return false;
 }
        if (
           searchParam=="status" && searchFilter[searchParam].length>0 && !(
            searchFilter[searchParam].includes(item[searchParam])
          )
        ) {
          return false;
        }
        if (
          searchParam=="name_english" && searchFilter[searchParam].length>0 && (
           !searchFilter[searchParam].includes(item[searchParam])
         )
       ) {
         return false;
       }
       if (
        searchParam=="country_of_shipper" && searchFilter[searchParam].length>0 && (
         !searchFilter[searchParam].includes(item[searchParam])
       )
     ) {
       return false;
     }
     if (
      searchParam=="type_of_shipment" && searchFilter[searchParam].length>0 && item[searchParam]!== null && searchFilter[searchParam] !=="" && searchFilter[searchParam]!==null &&(
        !searchFilter[searchParam].map(word=>word.trim().toLowerCase()).includes(item[searchParam].trim().toLowerCase())
     )
   ) {
     return false;
   }
   if (
    searchParam=="under_shipping_review" && searchFilter[searchParam].length>0 && (
     !searchFilter[searchParam].includes(item["review_by_shipping"])
     )
   ) {
     return false;
   }
    }
      return true;
    });

    setfilteredData(
      filteredData.map((val) => ({
        ...val,
        ...val.address_recipient_locked_data,
        ...(val.address_recipient_locked_data
          ? {
              firstname: val.address_recipient_locked_data.first_name,
              lastname: val.address_recipient_locked_data.last_name,
            }
          : null),
        ...(val.shipper_locked_data?.name_english
          ? {
              country_of_shipper: `${val.shipper_locked_data?.name_english}`,
            }
          : null),
        type_of_shipment: !ifRequestCompletedApprovals(val.status)
          ? shippingType.find(
              (item) => item.id === val.type_of_shipment && item.isactive
            )
            ? val.type_of_shipment
            : null
          : val.type_of_shipment,
      }))
    );
  }, [
    searchFilter,
    allMaterials,
    processShippmentList,
    shippingSearchAutocompleteData,
    shippingType,
  ]);
  const pathProcessShippingURLs = [
    "/requestByDelegate",
    "/approveAddress",
    "/approve/materials",
    "/approve/recipients",
    "/address",
    "/materials",
    "/recipients",
    "/shippingRequests",
    "/myShippings",
    "/regulatoryReviewer",
    "/comments",
    "/alerts",
    "/countrycatalouge",
    "/registereduser",
    "/queriesCountry",
    "/queriesCountryTwoWeeks",
    "/myAddress",
    "/my/application/materials",
    "/my/application/recipients",
    "/contact",
    "/phase",
    "/broker",
    "/container",
    "/add-country",
    "/currency",
    "/distributiontemperature",
    "/importerOfRecord",
    "/incoterm",
    "/shippingType",
    "/title",
    "/units",
    "/logistics",
  ]

  useEffect(() => {
    return () => {
      if (pathProcessShippingURLs.includes(window.location.pathname)) {
        actions.setProcessShippingTableOptions({});
        actions.setProcessShippingSearchData({});
      }
    };
  }, []);

  useEffect(() => {
    const persistedColumnVisibility = {
      ...defaultColumnVisibility,
      ...(tableProcessShippingOptions?.columnVisibility || {}),
    };

    if (!_.isEqual(persistedColumnVisibility, columnVisibility)) {
      setColumnVisibility(persistedColumnVisibility);
    }
  }, [tableProcessShippingOptions]);

  useEffect(() => {
    actions.setProcessShippingTableOptions({
      ...tableProcessShippingOptions,
      columnVisibility,
    });
  }, [columnVisibility]);

  const dispatchProcessShippingOptions = (event, value) => {
    if (event.target === "page") {
      return actions.setProcessShippingTableOptions({
        ...tableProcessShippingOptions,
        pageNumber: value.pageNumber,
        pageSize: value.pageSize,
        orderBy: tableProcessShippingOptions.orderBy,
        columnVisibility,
      });
    }
    if (event.target === "sort") {
      return actions.setProcessShippingTableOptions({
        ...tableProcessShippingOptions,
        pageNumber: 0,
        pageSize: tableProcessShippingOptions.pageSize,
        orderBy: value,
        columnVisibility,
      });
    }
  }
  const handleRadiobuttonChange = (data) => {
    setSelected(data);
  };
console.log("tableProcessShippingOptions",tableProcessShippingOptions)
  const handleCSVExport = async () => {
    let dataForExport = exportDataBuilder();
    let wb = utils.book_new(),
      ws = utils.json_to_sheet(dataForExport);
    utils.book_append_sheet(wb, ws, "Process_Shipping_Requests_Data");
    writeFile(wb, requiredFileName + ".xlsx");
  };

  const exportDataBuilder = () => {
    let copyOfFilteredData;
    if (filteredData.length === 0) {
      copyOfFilteredData = _.cloneDeep(filteredData);
    } else if (filteredData.length > 0) {
      copyOfFilteredData = _.cloneDeep(filteredData);
    }

   copyOfFilteredData && copyOfFilteredData?.forEach((item) => {
      //changing column names
      if (item.created_on) {
        item.created_on = DateFormat(item.created_on, i18n.resolvedLanguage);
      }
      if (item?.shipment_date_mon) {
        item.shipment_date_mon = DateFormatWithoutLocal(
          item.shipment_date_mon,
          i18n.resolvedLanguage
        );
      }
      if (item?.shipment_date_lev) {
        item.shipment_date_lev = DateFormatWithoutLocal(
          item.shipment_date_lev,
          i18n.resolvedLanguage
        );
      }
      if (item.date_material_needed_on_site) {
        item.date_material_needed_on_site = DateFormatWithoutLocal(
          item.date_material_needed_on_site,
          i18n.resolvedLanguage
        );
      }
      if (item.regulatory_reviewer1_created_on) {
        item.regulatory_reviewer1_created_on = DateFormat(
          item.regulatory_reviewer1_created_on,
          i18n.resolvedLanguage
        );
      }
      if (item.regulatory_reviewer2_created_on) {
        item.regulatory_reviewer2_created_on = DateFormat(
          item.regulatory_reviewer2_created_on,
          i18n.resolvedLanguage
        );
      }
      if (item.close_date) {
        item.close_date = DateFormatWithoutLocal(item.close_date, i18n.resolvedLanguage);
      }
      if (item.materialvalue) {
        item.materialvalue =
          item.materialvalue === null || item.materialvalue === undefined
            ? 0
            : parseInt(item?.materialvalue);
      }

      item["Shipping Request #"] = item["internal_distribution_number"];
      item["Create Date"] = item["created_on"];
      item["Created User"] = item["created_by"];
      item["Recipient "] =
        (item.firstname === null && item.lastname === null) ||
        (item.firstname === undefined && item.lastname === undefined)
          ? ""
          : item["firstname"] + " " + item["lastname"];
      item["Country of Destination"] =
        item["name_english"] === " ()" ? "" : item["name_english"];
      item["Dispatch Date - Elanco"] = item["shipment_date_mon"];
      item["Dispatch Date - Logistics Partner"] = item["shipment_date_lev"];
      item["Tracking Number"] = item["tracking_number"];
      item["Status"] = t("status." + item["status"]);
      item["Study Number "] = item["study_number"];
      item["Type of Shipment"] = shippingType.find(
        (x) => x.id === item["type_of_shipment"]
      )?.name;
      item["Delivered Date"] = item["close_date"];
      item["Shipper Company/University"] =
        item["destination_company_university"];
      item["Shipper Country"] =
        item["country_of_shipper"] === " ()" ? "" : item["country_of_shipper"];

      item["Destination Company/University"] = item["entity"];
      item["Destination Country"] =
        item["name_english"] === " ()" ? "" : item["name_english"];

      item["Regulatory Reviewer (1)"] =
        item["regulatory_reviewer1_approved_by"];
      item["Regulatory Reviewer (2)"] =
        item["regulatory_reviewer2_approved_by"];

      item["Regulatory Reviewer (1) Comments"] =
        item["regulatory_reviewer1_comments"];
      item["Regulatory Reviewer (2) Comments"] =
        item["regulatory_reviewer2_comments"];
      item["Total Value of Material"] =
        item?.usdvalue === null || item?.usdvalue === undefined
          ? item?.materialvalue === null || item?.materialvalue === undefined
            ? 0
            : parseInt(item?.materialvalue)
          : parseInt(item?.usdvalue) + parseInt(item?.restofworldvalue);


      item["Shipping Reviewer"] = item["shipping_reviewer_user"];
      item["Project"] = item["project_name"];

      delete item["usdvalue"];
      delete item["restofworldvalue"];
      delete item["materialvalue"];

      item["Material Name"] = item["description"];
      item["Batch Number"] =
        item?.batch === ";" || item?.batch === ";;" ? "" : item["batch"];

      item["Regulatory Reviewer (1) Approval Date"] =
        item["regulatory_reviewer1_created_on"];
      item["Regulatory Reviewer (2) Approval Date"] =
        item["regulatory_reviewer2_created_on"];

      item["Date Material Needed On Site"] =
        item["date_material_needed_on_site"];
        item["Under Shipping Review"]= item["review_by_shipping"];
      //   item["Shipping Reviewer"] = item["name_english"];
      delete item["study_number"];
      delete item["reciever_country"];
      delete item["origin_country"];
      delete item["label_inst_comments"];
      delete item["label_text"];
      delete item["is_special_label_req"];
      delete item["rec_country_comments"];
      delete item["reg_req_rec_country_met"];
      delete item["org_country_comments"];
      delete item["reg_req_org_country_met"];
      delete item["review_by_shipping"];
      delete item["is_shippment_hazardous"];
      delete item["shippment_hazardous_comments"];

      delete item["country_of_shipper"];
      delete item["destination_company_university"];
      delete item["name_english"];
      delete item["regulatory_reviewer1_approved_by"];
      delete item["regulatory_reviewer2_approved_by"];
      delete item["regulatory_reviewer1_comments"];
      delete item["regulatory_reviewer2_comments"];
      delete item["description"];

      delete item["batch"];
      delete item["regulatory_reviewer1_created_on"];
      delete item["regulatory_reviewer2_created_on"];
      delete item["date_material_needed_on_site"];

      delete item["shipper_locked_data"];
      delete item["address_recipient_locked_data"];

      delete item["shipping_req_id"];
      delete item["consignor_type"];
      delete item["country_of_shipper"];
      delete item["logistics_partner"];
      delete item["id"];
      delete item["address_id"];
      delete item["close_date"];
      delete item["distributiontemperature_id"];
      delete item["sap_delivery_number"];
      delete item["shipment_date_lev"];
      delete item["shipment_date_mon"];
      delete item["status"];
      delete item["tracking_number"];
      delete item["created_by"];
      delete item["first_name"];
      delete item["last_name"];
      delete item["firstname"];
      delete item["lastname"];
      delete item["form_of_address"];
      delete item["sapnumber"];
      delete item["name_english"];
      delete item["created_on"];
      delete item["handling_type"];

      delete item["recipient_id"];
      delete item["shipper_id"];
      delete item["c_comment"];
      delete item["id_old"];
      delete item["id_old_request"];
      delete item["internal_distribution_number"];
      delete item["shipment_constraint_date"];
      delete item["shipment_constraint_type"];
      delete item["status_comment"];
      delete item["valid"];
      delete item["c_comment"];
      delete item["updated_on"];
      delete item["updated_by"];
      delete item["is_active"];
      delete item["title_id"];
      delete item["approved"];
      delete item["email"];
      delete item["phone"];
      delete item["submitted"];
      delete item["country_id"];
      delete item["building"];
      delete item["city"];
      delete item["department"];
      delete item["entity"];
      delete item["postcode"];
      delete item["street"];
      delete item["code"];
      delete item["name"];
      delete item["attachment_comment"];
      delete item["inco_term"];
      delete item["cost_center_shipment"];
      delete item["type_of_shipment"];
      delete item["entity_name"];
      delete item["importer_records_address"];
      delete item["shipment_no"];
      delete item["is_reg_review_req"];
      delete item["prp_use_of_material"];
      delete item["pack_tot_weight"];
      delete item["pack_height"];
      delete item["pack_width"];
      delete item["pack_length"];
      delete item["is_mat_client_used_animal"];
      delete item["is_mat_food_produced_animal"];
      delete item["date_material_available_to_ship"];
      delete item["date_material_needed_on_site"];
      delete item["state"];

      delete item["importer_of_records"];
      delete item["state"];

      delete item["broker_id"];
      delete item["reviewer_comment"];
      delete item["shipping_id"];
      delete item["study_title"];
      delete item["person_responsible"];
      delete item["animal_designation"];
      delete item["regulatory_standard"];
      delete item["animals_required"];
      delete item["project_name"];
      delete item["activity_type"];
      delete item["intended_for_pivotal_evidence"];
      delete item["study_comment"];
      delete item["shipping_reviewer_user"];
      delete item["shipper_address_id"];
      delete item["review_by"];
      delete item["prefered_reviewer"];

      for (let key in item) {
        if (item[key] === null) {
          item[key] = "";
        }
      }
    });
    return _.cloneDeep(copyOfFilteredData);
  };

    const ExportSelectedBtn = async () => {
  
        // Get local timezone offset in minutes
        const timezoneOffsetMinutes = new Date().getTimezoneOffset();
        // Convert to hours: positive for behind UTC, negative for ahead of UTC
        const timezoneOffsetHours = -timezoneOffsetMinutes / 60; // e.g., IST: -330 -> 5.5
  
        // Append it to the URL as a query parameter
        const timezoneParam = `?timezone=${timezoneOffsetHours}`;
  
        const exportURL =
        config.baseURL +
        `/api/exportSelectedData/` +
        selected.id +
        "/" +
        requiredFileName +
        "/Process_Shipping_Requests_Data" +
          timezoneParam;
  
        window.location.href = exportURL;
    };
  // const handleStatusChange = async (status) => {
  //   if (selected?.id) {
  //     try {
  //       await shippingService.setShippingStatus({
  //         id: selected.id,
  //         status,
  //       });
  //       await actions.getProcessShippmentList();
  //       setSelected({ ...selected, status });
  //       toast.success(t("commonlabels.savedSuccessfullyMsg"));
  //     } catch (e) {
  //       console.error(e);
  //     }
  //   }
  // };

  const getStatusFlow = () => {
    if (actionName === INSPECT) {
      return (
        <StatusFlow
          row={shippingDetail}
          actionType={INSPECT}
          roleName={PROCESS_MANAGER}
          goBack={"/process/shipping"}
        />
      );
    }
  }
  
  const viewShipment = async (rowData) => {
    // StatusFlow must receive fresh request details before it can redirect.
    const response = await actions.getShippingRequestDetails(rowData);
    if (!response) return;
    // Do not pass cached form values: they belong to the previously opened request.
    shippingRequestEdit(response.data, { actions });
    setActionName(INSPECT);
    setShippingDetail(rowData);
    actions.redirectAction("/process/shipping");
  }

  const editShippment = async (row) => {
    const response = await actions.getShippingRequestDetails(row);
    if (!response) return;
    shippingRequestEdit(response.data, { actions });
    actions.redirectAction("/process/shipping");
    actions.getDeputyShippingDetails(row);
    actions.getMaterialShippingDetails(row);
    actions.getShippingActionType("EDIT");
    actions.clearShippingMaterialSelectedValue();
    actions.addShippingMaterialSelect([]);
    actions.getShippingAttachment(row);
    actions.getShipperDetails(row);
    actions.getAllShippingData();
    actions.saveTableData(row);
    history.push("/shipping");
  };
  
  const ExportBtn = () => {
    return (
      <button
        className="mr-1"
        onClick={() => {
          setIsExportModalVisible(true);
        }}
      >
        {t("export.exportall")}
      </button>
    );
  };
  const ExportSelectedBtnForSingle = () => {
    return (
      <button
        disabled={selected === ""}
        onClick={(e) => {
          setIsExportModalVisibleSingle(true);
        }}
      >
        {t("export.exportselected")}
      </button>
    );
  };
  const exportModalBody = () => {
    return (
      <div className="row  m0">
        <div className="col-12">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="form-group">
                <label className="col-form-label">
                  {t("exportLabel.fileName")}:
                </label>
                &nbsp;
                <input
                  type="text"
                  className="form-control custom-form-control"
                  value={requiredFileName}
                  onChange={(e) => {
                    setrequiredFileName(e.target.value);
                  }}
                ></input>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const exportModalFooter = () => {
    return (
      <>
        <button
          type="button"
          id="Yes"
          disabled={requiredFileName.trim() !== "" ? false : true}
          className="btn btn-primary btn-inner-close"
          onClick={(e) => {
            handleCSVExport();
            setIsExportModalVisible(false);
            setrequiredFileName("");
          }}
        >
          {t("export.export")}
        </button>

        <button
          type="button"
          id="Close"
          //disabled={isModalSaveRunning}
          className="btn btn-black btn-inner-close cancel_button"
          onClick={(e) => {
            setIsExportModalVisible(false);
            setrequiredFileName("");
          }}
        >
          Cancel
        </button>
      </>
    );
  };
  const exportModalBodySingleData = () => {
    return (
      <div className="row  m0">
        <div className="col-12">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="form-group">
                <label className="col-form-label">
                  {t("exportLabel.fileName")}:
                </label>
                &nbsp;
                <input
                  type="text"
                  className="form-control custom-form-control"
                  value={requiredFileName}
                  onChange={(e) => {
                    setrequiredFileName(e.target.value);
                  }}
                ></input>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const validateRevokebutton = () =>{
    return get(selected, "id", 0) === 0 ||
    ![STATUS.READY_FOR_DELIVERY].includes(selected?.status)
    setSelected("")

  }

  const exportModalFooterSingleData = () => {
    return (
      <>
        <button
          type="button"
          id="Yes"
          disabled={requiredFileName.trim() !== "" ? false : true}
          className="btn btn-primary btn-inner-close"
          onClick={(e) => {
            ExportSelectedBtn();
            setIsExportModalVisibleSingle(false);
            setrequiredFileName("");
          }}
        >
          Export
        </button>
        <button
          type="button"
          id="Close"
          //disabled={isModalSaveRunning}
          className="btn btn-black btn-inner-close cancel_button"
          onClick={(e) => {
            setIsExportModalVisibleSingle(false);
            setrequiredFileName("");
          }}
        >
          Cancel
        </button>
      </>
    );
  };

  return (
    <>
      <style>{`
        .mat-tooltip-custom {
          padding: 0 !important;
          border-radius: 8px !important;
          box-shadow: 0 6px 24px rgba(26,134,206,0.18), 0 2px 8px rgba(0,0,0,0.10) !important;
          max-width: none !important;
          z-index: 99999 !important;
          opacity: 1 !important;
          pointer-events: auto !important;
          background-color: #fff !important;
        }
        .mat-tooltip-custom.place-right::after { border-right-color: #1a86ce !important; }
        .mat-tooltip-custom.place-left::after  { border-left-color: #1a86ce !important; }
        .mat-tooltip-custom.place-top::after   { border-top-color: #1a86ce !important; }
        .mat-tooltip-custom.place-bottom::after{ border-bottom-color: #1a86ce !important; }
      `}</style>
      {/* Centered Show/Hide Columns Dialog - rendered outside MaterialTable to avoid flicker */}
      {(() => {
        const allVisible = Object.values(columnVisibility).every(v => v);
        const someVisible = Object.values(columnVisibility).some(v => v);
        return (
          <Dialog
            open={columnsPopupOpen}
            onClose={(event, reason) => { if (reason !== "backdropClick" && reason !== "escapeKeyDown") setColumnsPopupOpen(false); }}
            PaperProps={{
              style: {
                borderRadius: "10px",
                minWidth: "480px",
                maxWidth: "600px",
                boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
              }
            }}
          >
            <DialogTitle style={{
              display: "flex", justifyContent: "space-between", alignItems: "center",
              padding: "14px 20px 10px",
              borderBottom: "1px solid #e0e0e0",
              fontSize: "15px", fontWeight: "700", color: "#414141",
            }}>
              {t("commonlabels.showHideColumns")}
              <span
                style={{ cursor: "pointer", color: "#999", fontSize: "22px", lineHeight: 1, marginLeft: "auto" }}
                onClick={(e) => { e.stopPropagation(); setColumnsPopupOpen(false); }}
              >×</span>
            </DialogTitle>
            <DialogContent style={{ padding: "12px 20px 16px" }}>
              <div style={{
                display: "flex", alignItems: "center", gap: "10px",
                padding: "8px 0", cursor: "default",
                fontSize: "13px", color: "#414141", fontWeight: "600",
                borderBottom: "1px solid #ebebeb", marginBottom: "4px",
              }}>
                <input
                  type="checkbox"
                  checked={allVisible}
                  ref={el => { if (el) el.indeterminate = someVisible && !allVisible; }}
                  onChange={(e) =>
                    setColumnVisibility(Object.fromEntries(Object.keys(columnVisibility).map(k => [k, e.target.checked])))
                  }
                  style={{ width: "15px", height: "15px", accentColor: "#1a86ce", cursor: "pointer", flexShrink: 0 }}
                />
                {t("commonlabels.selectAll")}
              </div>
              {columnToggleList.map(({ key, label }) => (
                <div key={key} style={{
                  display: "flex", alignItems: "center", gap: "10px",
                  padding: "5px 0", cursor: "default",
                  fontSize: "13px", color: "#555",
                }}>
                  <input
                    type="checkbox"
                    checked={columnVisibility[key] ?? true}
                    onChange={(e) => setColumnVisibility(prev => ({ ...prev, [key]: e.target.checked }))}
                    style={{ width: "15px", height: "15px", accentColor: "#1a86ce", cursor: "pointer", flexShrink: 0 }}
                  />
                  {label}
                </div>
              ))}
            </DialogContent>
          </Dialog>
        );
      })()}
      {
        Object.keys(shippingDetail).length > 0 &&
          shippingDetail.id !== 0 &&
          getStatusFlow()
      }
      <div className="row m0 no_padding container-fluid ">
        <div className="no_padding col-12 mt-3 mb-2 d-flex justify-content-end">
          {userType.includes(USERROLES.PROCESSMANAGER) === true ? (
            <div className="buttonsec_animalmanagment">
              <DropdownButton
                title={t("export.export")}
                className="mr-1 exportdropdown"
              >
                <Dropdown.Item>{ExportBtn()}</Dropdown.Item>
                <Dropdown.Item>{ExportSelectedBtnForSingle()}</Dropdown.Item>
              </DropdownButton>

              <button
                className="btn btn-primary new_button mr-1"
                disabled={get(selected, "id", 0) === 0 ? true : false}
                onClick={() => {
                  history.push(`/shippings/log/${selected?.id}`);
                  actions.saveTableData(selected);
                }}
              >
                {t("shippingrequest.log")}
              </button>

              <button
                className="btn btn-primary new_button"
                disabled={ validateRevokebutton()
                    ? true
                    : false
                }
                onClick={async () => {
                  try {
                    setIsLoading(true);
                    await actions.revertApproval(selected.id,selected.status,userId);
                    await actions.getProcessShippmentList();
                    handleRadiobuttonChange(null)
                  } catch (e) {}
                  setIsLoading(false);
                }}
              >
                {t("regulatoryReview.revoke_approval")}
              </button>
            </div>
          ) : (
            <div className="buttonsec_animalmanagment">
              <button
                className="btn btn-primary new_button"
                disabled={get(selected, "id", 0) === 0 ? true : false}
                onClick={() => handlerShippingInspect(selected)}
              >
                {t("shippingrequest.inspect")}
              </button>
            </div>
          )}
        </div>
      </div>
      <Card variant="outlined">
        <CardHeader
          title={
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <span>{t("approve_recipient.search_text")}</span>
              <button
                className="btn btn-sm btn-outline-secondary"
                style={{ color: "#1a86ce", fontSize: "12px", fontWeight: "bold" }}
                onClick={() => resetColumnsRef.current()}
              >
                {t("commonlabels.resetColumns")}
              </button>
              <button
                className="btn btn-sm btn-outline-secondary"
                style={{ color: "#1a86ce", fontSize: "12px", fontWeight: "bold" }}
                onClick={() => openPopupRef.current()}
              >
                {t("commonlabels.showHideColumns")}
              </button>
            </div>
          }
        />
        <Divider />
        <CardContent>
          <div style={{ paddingBottom: "2%" }}>
          {filteredData?.length>0 &&
            <MaterialTable
           // key={columnsResetKey}
            onPageChange={(page, itemsPerPage) => {
              dispatchProcessShippingOptions({ target: "page" }, { "pageNumber": page, "pageSize": itemsPerPage });
            }}
            onOrderCollectionChange={(orderBy) => {
              dispatchProcessShippingOptions({ target: "sort" }, orderBy);
            }}
              columns={[
                {
                  width: "4%",
                  hiddenByColumnsButton: true,
                  render: (rowData) => (
                    <input
                      type="radio"
                      value={get(selected, "id", "")}
                      name="radiovalues"
                      className={classes.tableRadio}
                      onChange={(e) => handleRadiobuttonChange(rowData)}
                    />
                  ),
                  sorting: false,
                },
                {
                  title: <span>{t("shippingrequest.internalorderid")}</span>,
                  field: `internal_distribution_number`,
                  hidden: !columnVisibility.internal_distribution_number,
                  customSort: (d1,d2)=>{
                    let n1 = d1?.internal_distribution_number.split(/[_ -]/)
                    let n2 = d2?.internal_distribution_number.split(/[_ -]/)
                    if(n1[2] != n2[2]){
                      return parseInt(n1[2]) - parseInt(n2[2]);
                    }
                    else if(n1[1] != n2[1] && months.hasOwnProperty(n1[1]) && months.hasOwnProperty(n2[2])){
                      return ++months[n1[1]] - ++months[n2[2]];
                    }
                    else{
                      return parseInt(n1[0]) - parseInt(n2[0])
                    }
                  }
                },
                {
                  title: <span>{t("materials.create_date")}</span>,
                  hidden: !columnVisibility.create_date,
                  render: (rowData) => (
                    <span>{DateFormat(rowData.created_on, i18n.resolvedLanguage)}</span>
                  ),
                  customSort: (ct1,ct2)=>{
                    let n1 = ct1?.created_on.split(/[- T]/)
                    let n2 = ct2?.created_on.split(/[ - T]/)
                    if(n1[0]!=n2[0]){
                      return parseInt(n1[0]) - parseInt(n2[0]);
                    }else if(n1[1] != n2[1] && months.hasOwnProperty(n1[1]) && months.hasOwnProperty(n2[2])){
                      return ++months[n1[1]] - ++months[n2[2]];
                    }else{
                      return parseInt(n1[2]) - parseInt(n2[2])
                    }
                    
                  }
                },
                {
                  title: <span>{t("materials.create_user")}</span>,
                  field: "created_by",
                  hidden: !columnVisibility.created_by,
                  customSort: (crt1,crt2)=>{
                    let ncrt1=crt1.created_by.split(/[@]/)
                    let ncrt2=crt2.created_by.split(/[@]/)
                    if(ncrt1[0]!=ncrt2[0])
                    return ncrt1[0].localeCompare(ncrt2[0])
                  }
                },
                {
                  title: <span>{t("shippingrequest.finalrecipient")}</span>,
                  hidden: !columnVisibility.final_recipient,
                  customSort: (a, b) => {
                    if (
                      (a.firstname + a.lastname).toString().toLowerCase() >
                      (b.firstname + b.lastname).toString().toLowerCase()
                    ) {
                      return -1;
                    } else if (
                      (a.firstname + a.lastname).toString().toLowerCase() <
                      (b.firstname + b.lastname).toString().toLowerCase()
                    ) {
                      return 1;
                    } else {
                      return 0;
                    }
                  },
                  render: (rowData) =>
                    (rowData.firstname ? rowData.firstname : "") +
                    +" " +
                    (rowData.lastname ? rowData.lastname : ""),
                  customSort: (a, b) => {
                    if (
                      (a.firstname + a.lastname).toString().toLowerCase() >
                      (b.firstname + b.lastname).toString().toLowerCase()
                    ) {
                      return -1;
                    } else if (
                      (a.firstname + a.lastname).toString().toLowerCase() <
                      (b.firstname + b.lastname).toString().toLowerCase()
                    ) {
                      return 1;
                    } else {
                      return 0;
                    }
                  },
                  render: (rowData) =>
                    (rowData.firstname ? rowData.firstname : "") +
                    " " +
                    (rowData.lastname ? rowData.lastname : ""),
                },

                {
                  title: <span>{t("shippingrequest.addreesedcountry")}</span>,
                  hidden: !columnVisibility.name_english,
                  render: (rowData) => {
                    if (rowData.name_english === " ()") {
                      return "";
                    } else {
                      return rowData.name_english;
                    }
                  },
                  customSort: SortFunctionNew("name_english"),
                },
                {
                  title: <span>{t("shippingrequest.country_of_shipper")}</span>,
                  hidden: !columnVisibility.country_of_shipper,
                  render: (rowData) => {
                    if (rowData.country_of_shipper === " ()") {
                      return "";
                    } else {
                      return rowData.country_of_shipper;
                    }
                  },
                  customSort: SortFunctionNew("country_of_shipper"),
                },
                {
                  title: <span>{t("title.ShipmentType")}</span>,
                  field: "type_of_shipment",
                  hidden: !columnVisibility.type_of_shipment,
                  render: (rowData) => (
                    rowData.type_of_shipment==="INNER_EU"?"WITHIN EU":rowData.type_of_shipment==="DOMESTIC"?"DOMESTIC US":rowData.type_of_shipment
                  ),
                  customSort: (spt1,spt2)=>{
                      let types = {
                        "INNER_EU":"WITHINEU","DOMESTIC" :"DOMESTICUS ","INTERNATIONAL": "INTERNATIONAL"
                      }
                      let vals = Object.keys(types);
                      if(vals.includes(spt1.type_of_shipment) &&  vals.includes(spt2.type_of_shipment)){
                        return types[spt1.type_of_shipment].localeCompare(types[spt2.type_of_shipment])
                      }

                  }
                },
                {
                  title: <span>{t("shippingrequest.dispatchdate(mon)")}</span>,
                  hidden: !columnVisibility.shipment_date_mon,
                  render: (rowData) => (
                    <span>
                      {rowData.shipment_date_mon &&
                        DateFormatWithoutLocal(rowData.shipment_date_mon, i18n.resolvedLanguage)}
                    </span>
                  ),
                  customSort: dateSortFunction("shipment_date_mon"),
                },
                {
                  title: <span>{t("shippingrequest.dispatchdate(lev)")}</span>,
                  hidden: !columnVisibility.shipment_date_lev,
                  render: (rowData) => (
                    <span>
                      {rowData.shipment_date_lev &&
                        DateFormatWithoutLocal(rowData.shipment_date_lev, i18n.resolvedLanguage)}
                    </span>
                  ),
                  customSort: dateSortFunction("shipment_date_lev"),
                },
                {
                  title: <span>{t("shippingrequest.trackingnumber")}</span>,
                  field: "tracking_number",
                  hidden: !columnVisibility.tracking_number,
                  customSort: SortFunctionNew("tracking_number"),
                },
                {
                  title: <span>{t("shippingrequest.status")}</span>,
                  hidden: !columnVisibility.status,
                  render: (rowData) => t("status." + rowData.status),
                  customSort: (st1,st2)=>{
                    let nst1=st1.status.trim()
                    let nst2=st2.status.trim()
                    return status[nst1].localeCompare(status[nst2])
                  }
                  
                },
                {
                  title: <span>{t("shipping_request.assigned_shipping_review")}</span>,
                  field: "review_by_shipping",
                  hidden: !columnVisibility.review_by_shipping,
                  customSort: sortFunction("review_by_shipping"),
                },
                {
                  title: <span>Materials</span>,
                  hidden: !columnVisibility.stat_materials,
                  sorting: false,
                  render: (rowData) => {
                    const materials = shippingSearchAutocompleteData?.materialData?.filter(
                      (m) => m.shipping_request_id === rowData.id
                    ) || [];
                    if (!materials.length) return <span style={{ color: "#aaa" }}>—</span>;
                    const tooltipTable = (
                      <div style={{ background: "#fff", borderRadius: "8px", width: "min(400px, 85vw)", maxWidth: "400px", boxSizing: "border-box", overflow: "hidden" }}>
                        {/* Header - sticky so it stays visible while scrolling */}
                        <div style={{
                          background: "linear-gradient(90deg, #1a86ce 0%, #2196f3 100%)",
                          padding: "8px 12px",
                          display: "flex", alignItems: "center", gap: "8px",
                          borderRadius: "8px 8px 0 0",
                          position: "sticky", top: 0, zIndex: 1,
                        }}>
                          <span style={{ fontSize: "12px", fontWeight: "700", color: "#fff", letterSpacing: "0.3px" }}>
                            Materials
                          </span>
                          <span style={{
                            background: "rgba(255,255,255,0.25)", color: "#fff",
                            fontSize: "11px", fontWeight: "700",
                            borderRadius: "10px", padding: "1px 7px",
                          }}>
                            {materials.length}
                          </span>
                        </div>
                        {/* Scrollable table body */}
                        <div style={{ overflowY: "auto", overflowX: "auto", maxHeight: "220px", scrollBehavior: "smooth" }}>
                          <table style={{ borderCollapse: "collapse", fontSize: "11px", width: "100%", tableLayout: "fixed", minWidth: "360px" }}>
                            <colgroup>
                              <col style={{ width: "45%" }} />
                              <col style={{ width: "18%" }} />
                              <col style={{ width: "19%" }} />
                              <col style={{ width: "18%" }} />
                            </colgroup>
                            <thead style={{ position: "sticky", top: 0, zIndex: 1 }}>
                              <tr style={{ background: "#f4f8fb" }}>
                                <th style={{ padding: "6px 10px", textAlign: "left", fontWeight: "600", color: "#1a86ce", fontSize: "10px", textTransform: "uppercase", letterSpacing: "0.5px" }}>{t("material.materialName")}</th>
                                <th style={{ padding: "6px 8px", textAlign: "left", fontWeight: "600", color: "#1a86ce", fontSize: "10px", textTransform: "uppercase", letterSpacing: "0.5px" }}>{t("materials.hs_foreign")}</th>
                                <th style={{ padding: "6px 8px", textAlign: "left", fontWeight: "600", color: "#1a86ce", fontSize: "10px", textTransform: "uppercase", letterSpacing: "0.5px" }}>{t("materials.hs_germany")}</th>
                                <th style={{ padding: "6px 8px", textAlign: "left", fontWeight: "600", color: "#1a86ce", fontSize: "10px", textTransform: "uppercase", letterSpacing: "0.5px" }}>{t("materials.htsus")}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {materials.map((m, i) => (
                                <tr key={i} style={{ backgroundColor: i % 2 === 0 ? "#fff" : "#f7fbff" }}>
                                  <td style={{ padding: "5px 10px", color: "#333", wordBreak: "break-word", fontWeight: "500" }}>{m.description || "—"}</td>
                                  <td style={{ padding: "5px 8px", color: "#555" }}>{m.statistical_material_number_china || "—"}</td>
                                  <td style={{ padding: "5px 8px", color: "#555" }}>{m.statistical_material_number_grmny || "—"}</td>
                                  <td style={{ padding: "5px 8px", color: "#555" }}>{m.statistical_material_number_usa || "—"}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    );
                    const tipId = `mat-tip-${rowData.id}`;
                    return (
                      <>
                        <span
                          data-tip=""
                          data-for={tipId}
                          style={{
                            cursor: "pointer",
                            color: "#1a86ce",
                            fontWeight: "600",
                            fontSize: "12px",
                            background: "#e8f4fd",
                            borderRadius: "12px",
                            padding: "2px 10px",
                            border: "1px solid #b3d9f5",
                            display: "inline-block",
                            transition: "all 0.2s",
                          }}
                        >
                          {`${materials.length}`}
                        </span>
                        <ReactTooltip
                          id={tipId}
                          place="right"
                          effect="solid"
                          type="light"
                          border={false}
                          clickable
                          className="mat-tooltip-custom"
                          overridePosition={({ left, top }, currentEvent, currentTarget, node) => {
                            const vw = document.documentElement.clientWidth;
                            const vh = document.documentElement.clientHeight;
                            left = Math.min(vw - node.clientWidth - 8, Math.max(8, left));
                            top = Math.min(vh - node.clientHeight - 8, Math.max(8, top));
                            return { top, left };
                          }}
                        >
                          {tooltipTable}
                        </ReactTooltip>
                      </>
                    );
                  },
                },
                {
                  title: <span>{t("shippingrequest.logistics_partner")}</span>,
                  field: "logistics_partner",
                  hidden: !columnVisibility.logistics_partner,
                  customSort: SortFunctionNew("logistics_partner"),
                },
                // {
                //   title: <span>{t("shippingrequest.sapnumber")}</span>,
                //   field: "sap_delivery_number",
                //   customSort: SortFunctionNew("sap_delivery_number"),
                // },
                // {
                //   title: <span>Id</span>,
                //   field: "id",
                //   customSort: (a, b) => {
                //     if (parseInt(a.id) > parseInt(b.id)) {
                //       return -1;
                //     } else if (parseInt(a.id) < parseInt(b.id)) {
                //       return 1;
                //     } else {
                //       return 0;
                //     }
                //   },
                // },
                {
                  title: <span></span>,
                  sorting: false,
                  hiddenByColumnsButton: true,
                  render: (rowData) =>
                    userType.includes(USERROLES.PROCESSMANAGER) === true ? (
                      rowData.status === STATUS.READY_FOR_DELIVERY || rowData.status === STATUS.INBOX ? (
                        <span>
                          <Link to="/shipping" onClick={(event) => {
                            event.preventDefault();
                            editShippment(rowData);
                          }}>
                            <img alt="t" className="" src={editIcon}></img>{" "}
                          </Link>
                        </span>
                      ) : (
                        <span>
                          <Link onClick={(event) => {
                            event.preventDefault();
                            viewShipment(rowData);
                          }}>
                            <img alt="t" className="iconsize" src={viewIcon}></img>{" "}
                          </Link>
                        </span>
                      )
                    ) : (
                      <span></span>
                    ),
                },
              ]}
              data={(filteredData)}
              title="Render Image Preview"
              icons={tableIcons}
              localization={{
                pagination: {
                  labelRowsSelect: t("commonlabels.labelRowsSelect"),
                  firstAriaLabel: t("commonlabels.firstAriaLabel"),
                  firstTooltip: t("commonlabels.firstTooltip"),
                  previousAriaLabel: t("commonlabels.previousAriaLabel"),
                  previousTooltip: t("commonlabels.previousTooltip"),
                  nextAriaLabel: t("commonlabels.nextAriaLabel"),
                  nextTooltip: t("commonlabels.nextTooltip"),
                  lastAriaLabel: t("commonlabels.lastAriaLabel"),
                  lastTooltip: t("commonlabels.lastTooltip"),
                },
                body: {
                  emptyDataSourceMessage: t(
                    "commonlabels.emptyDataSourceMessage"
                  ),
                },
              }}
              options={{
                thirdSortClick: false,
                draggable: false,
                headerStyle: {
                  backgroundColor: "#cce3f5",
                  fontWeight: "bold",
                  height: "10px",
                },
                rowStyle: tableRowFormatter({
                  height: "30px",
                  padding: "0px",
                }),
                initialPage: parseInt(tableProcessShippingOptions?.pageNumber ? tableProcessShippingOptions?.pageNumber : 0),
                sortIcon: true,
                maxBodyHeight: "90%",
                tableLayout: "auto",
                sorting: true,
                search: false,
                selection: false,
                showTitle: false,
                toolbar: false,
                paging: true,
                paginationType: "stepped",
                pageSize: parseInt(tableProcessShippingOptions?.pageSize ? tableProcessShippingOptions?.pageSize : 10),
                defaultOrderByCollection: tableProcessShippingOptions?.orderBy ? tableProcessShippingOptions?.orderBy : "",
               
                pageSizeOptions: [10, 20, 30, 40,50],
                emptyRowsWhenPaging: false,
                showSelectAllCheckbox: false,
              }}
            />
          }
          {!filteredData?.length &&
            <MaterialTable
           //  key={columnsResetKey}
              columns={[
                {
                  width: "4%",
                  render: (rowData) => (
                    <input
                      type="radio"
                      value={get(selected, "id", "")}
                      name="radiovalues"
                      className={classes.tableRadio}
                      onChange={(e) => handleRadiobuttonChange(rowData)}
                    />
                  ),
                  sorting: false,
                },
                {
                  title: <span>{t("shippingrequest.internalorderid")}</span>,
                  hidden: true,
                },
                {
                  title: <span>{t("materials.create_date")}</span>,
                  hidden: true,
                },
                {
                  title: <span>{t("materials.create_user")}</span>,
                 hidden: true,
                },
                {
                  title: <span>{t("shippingrequest.finalrecipient")}</span>,
                 },

                {
                  title: <span>{t("shippingrequest.addreesedcountry")}</span>,
                
                },
                {
                  title: <span>{t("shippingrequest.country_of_shipper")}</span>,
                 
                },
                {
                  title: <span>{t("title.ShipmentType")}</span>,
                  
                },
                {
                  title: <span>{t("shippingrequest.dispatchdate(mon)")}</span>,
                  
                },
                {
                  title: <span>{t("shippingrequest.dispatchdate(lev)")}</span>,
                 
               
                },
                {
                  title: <span>{t("shippingrequest.trackingnumber")}</span>,
                 
                },
                {
                  title: <span>{t("shippingrequest.status")}</span>,
                 
                },
                {
                  title: <span>Materials</span>,
                  hidden: true,
                },
              ]}
              data={(filteredData)}
              title="Render Image Preview"
              icons={tableIcons}
              localization={{
                pagination: {
                  labelRowsSelect: t("commonlabels.labelRowsSelect"),
                  firstAriaLabel: t("commonlabels.firstAriaLabel"),
                  firstTooltip: t("commonlabels.firstTooltip"),
                  previousAriaLabel: t("commonlabels.previousAriaLabel"),
                  previousTooltip: t("commonlabels.previousTooltip"),
                  nextAriaLabel: t("commonlabels.nextAriaLabel"),
                  nextTooltip: t("commonlabels.nextTooltip"),
                  lastAriaLabel: t("commonlabels.lastAriaLabel"),
                  lastTooltip: t("commonlabels.lastTooltip"),
                },
                body: {
                  emptyDataSourceMessage: t(
                    "commonlabels.emptyDataSourceMessage"
                  ),
                },
              }}
              options={{
                thirdSortClick: false,
                draggable: false,
                headerStyle: {
                  backgroundColor: "#cce3f5",
                  fontWeight: "bold",
                  height: "10px",
                },
                rowStyle: tableRowFormatter({
                  height: "30px",
                  padding: "0px",
                }),
                sortIcon: true,
                maxBodyHeight: "90%",
                tableLayout: "auto",
                sorting: true,
                search: false,
                selection: false,
                showTitle: false,
                toolbar: false,
                paging: true,
                paginationType: "stepped",
                pageSize: 10,
                pageSizeOptions: [10, 20, 30, 40,50],
                emptyRowsWhenPaging: false,
                showSelectAllCheckbox: false,
              }}
            />
          }
          
          </div>
        </CardContent>
      </Card>
      {userType.includes(USERROLES.PROCESSMANAGER) === true ? (
        <div className="no_padding col-12 ">
          <div className={classes.actionButtonsTop}>
            <button
              className="btn btn-primary new_button mr-2"
              disabled={!(selected?.id && ["INBOX"].includes(selected?.status))}
              onClick={() => handleHandBack(selected)}
            >
              {t("approve_materials.handBack")}
            </button>

            {/* <button
              className="btn btn-primary new_button mr-2"
              disabled={get(selected, "id", 0) === 0 ? true : false}
              onClick={() => handleCloseRequest(selected)}
            >
              {t("approve_materials.close")}
            </button> */}

            <button
              className="btn btn-primary new_button"
              disabled={get(selected, "id", 0) === 0 ? true : !["INBOX", "READY_FOR_DELIVERY"].includes(selected?.status) ? true : false}
              onClick={() => handleCancelRequest(selected)}
            >
              {t("approve_materials.cancelRequest")}
            </button>
          </div>
        </div>
      ) : (
        <div></div>
      )}

      <Model
        showheader={isExportModalVisible}
        modalHeader={t("exportLabel.title")}
        modalbody={exportModalBody()}
        modalfooter={exportModalFooter()}
      ></Model>
      <Model
        showheader={isExportModalVisibleSingle}
        modalHeader={t("exportLabel.title")}
        modalbody={exportModalBodySingleData()}
        modalfooter={exportModalFooterSingleData()}
      ></Model>
    </>
  );
};

export default ProcessShippingRequestListingComponent;